import { render, staticRenderFns } from "./Xmdt.vue?vue&type=template&id=981481c2&scoped=true&"
import script from "./Xmdt.vue?vue&type=script&lang=js&"
export * from "./Xmdt.vue?vue&type=script&lang=js&"
import style0 from "./Xmdt.vue?vue&type=style&index=0&id=981481c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981481c2",
  null
  
)

export default component.exports